import { createRouter as createVueRouter, createWebHistory } from 'vue-router'

const LoginC = () => import('../components/Auth/LoginC.vue')
const ForgotC = () => import('../components/Auth/ForgotC.vue')
//const CreateAccountByEmail = () => import('../components/Auth/CreateAccountByEmail.vue')

const Dashboard = () => import('../components/Dashboard/Dashboard.vue')
const MembersList = () => import('../components/Members/List.vue')
const MemberSettings = () => import('../components/Members/Settings.vue')
const MembersSingle = () => import('../components/Members/Single.vue')
const MembershipCardList = () => import('../components/MembershipCards/List.vue')
const PaymentsList = () => import('../components/Payments/ListC.vue')
const ReportOverview = () => import('../components/Reports/Overview.vue')
const ApiSecretsSingle = () => import('../components/ApiSecrets/ApiSecretsSingle.vue')
const Logout = () => import('../components/Auth/Logout.vue')
const MembershipCardVerify = () => import('../components/MembershipCards/Verify.vue')
const MembershipCardSingle = () => import('../components/MembershipCards/Single.vue')
const MembershipCardLettersSingle = () => import('../components/MembershipCardLetters/Single.vue')
const MembershipCardVerifyMultiple = () =>
  import('../components/MembershipCards/VerifyMultiple.vue')
const MembershipCardSettings = () => import('../components/MembershipCards/Settings.vue')
const MemberApplicationsList = () => import('../components/MemberApplications/List.vue')
const MemberApplicationsSingle = () => import('../components/MemberApplications/Single.vue')
const MemberApplicationsVerification = () =>
  import('../components/MemberApplications/Verification.vue')
const MemberApplicationSettings = () => import('../components/MemberApplications/Settings.vue')
const MessagesList = () => import('../components/Messages/List.vue')
const MessagesSingle = () => import('../components/Messages/Single.vue')
const MessageSettings = () => import('../components/Messages/Settings.vue')
const NotFound = () => import('../components/NotFound/NotFound.vue')
const PaymentsC = () => import('../components/Payments/PaymentsC.vue')
const PaymentsSingle = () => import('../components/Payments/Single.vue')
const PaymentsUnpaid = () => import('../components/Payments/Unpaid.vue')
const PaymentsUnpaidSingle = () => import('../components/Payments/UnpaidSingle.vue')
const PaymentsNotifyMultiple = () => import('../components/Payments/NotifyMultiple.vue')
const Recover = () => import('../components/Auth/Recover.vue')
const TreasuryDocList = () => import('../components/TreasuryDocs/ListC.vue')
const TreasuryDocSingle = () => import('../components/TreasuryDocs/Single.vue')
const TreasuryDocsMultiple = () => import('../components/TreasuryDocs/Multiple.vue')
const TreasuryDocSettings = () => import('../components/TreasuryDocs/Settings.vue')
const UserSettings = () => import('../components/Users/Settings.vue')
const UsersSingle = () => import('../components/Users/Single.vue')
const UsersEditPassword = () => import('../components/Users/EditPassword.vue')
const Developers = () => import('../components/Developers/Developers.vue')

import { orgTerms } from '@/terminology'

const createRoutes = () => {
  return [
    {
      path: '/',
      name: 'home',
      redirect: '/autorizacao/entrar',
    },
    {
      path: '/autorizacao/entrar',
      name: 'login',
      component: LoginC,
      meta: {
        title: 'Entrar',
      },
    },

    {
      path: '/autorizacao/loginporlink',
      name: 'forgot',
      component: ForgotC,
      meta: {
        title: 'Login Por Link',
      },
    },
    /*{
      path: '/autorizacao/criarPorEmail',
      name: 'createAccountByEmail',
      component: CreateAccountByEmail,
      meta: {
        title: 'Criar Conta',
      },
    },*/
    {
      path: '/adminHome',
      name: 'adminHome',
      redirect: '/' + orgTerms.memberURLPlural,
      meta: {
        breadcrumb: orgTerms.memberPlural,
      },
    },
    {
      path: '/dashboard',
      name: 'memberHome',
      component: Dashboard,
      meta: {
        breadcrumb: orgTerms.memberSingular,
      },
    },
    {
      path: '/' + orgTerms.memberURLPlural,
      name: 'membersList',
      component: MembersList,
      meta: {
        title: orgTerms.memberPlural,
        breadcrumb: orgTerms.memberPlural,
      },
    },
    {
      path: '/' + orgTerms.memberURLPlural + '/novo',
      name: 'membersNew',
      component: MembersSingle,
      meta: {
        title: 'Novo ' + orgTerms.memberSingular,
        breadcrumb: 'Novo ' + orgTerms.memberSingular,
      },
    },
    {
      path: '/' + orgTerms.memberURLPlural + '/:id',
      name: 'membersEdit',
      component: MembersSingle,
      meta: {
        title: 'Editar ' + orgTerms.memberSingular,
        breadcrumb: 'Editar ' + orgTerms.memberSingular,
      },
    },
    {
      path:
        '/configuracao' +
        orgTerms.memberURLPlural.charAt(0).toUpperCase() +
        orgTerms.memberURLPlural.substring(1),
      name: 'memberSettings',
      component: MemberSettings,
      meta: {
        title: 'Configurações – ' + orgTerms.memberPlural,
        breadcrumb: 'Configurações – ' + orgTerms.memberPlural,
        module: 'settings',
      },
    },
    {
      path: '/candidaturas/nova',
      name: 'memberApplicationsNew',
      component: MemberApplicationsSingle,
      meta: {
        title: 'Nova Candidatura',
        breadcrumb: 'Nova Candidatura',
      },
    },
    {
      path: '/candidaturas/:id',
      name: 'memberApplicationsEdit',
      component: MemberApplicationsSingle,
      meta: {
        title: 'Editar candidatura de ' + orgTerms.memberSingular,
        breadcrumb: 'Editar candidatura de ' + orgTerms.memberSingular,
      },
    },
    {
      path: '/candidaturas',
      name: 'memberApplicationsList',
      component: MemberApplicationsList,
      meta: {
        title: 'Candidaturas a ' + orgTerms.memberSingular,
        breadcrumb: 'Candidaturas a ' + orgTerms.memberSingular,
      },
    },
    {
      path: '/configuracaoCandidaturas',
      name: 'memberApplicationSettings',
      component: MemberApplicationSettings,
      meta: {
        title: 'Configurações – Candidaturas a ' + orgTerms.memberSingular,
        breadcrumb: 'Configurações – Candidaturas a ' + orgTerms.memberSingular,
        module: 'settings',
      },
    },
    {
      path: '/inscricao/confirmacao/:verificationCode',
      name: 'memberApplicationsVarification',
      component: MemberApplicationsVerification,
      meta: {
        title: 'Verificação de Email',
        breadcrumb: 'Verificação de Email',
      },
    },

    {
      path: '/autorizacao/sair',
      name: 'logout',
      component: Logout,
    },
    {
      path: '/autorizacao/loginporlink/:recoverCode',
      name: 'recover',
      component: Recover,
      meta: {
        breadcrumb: 'Login por Link',
      },
    },
    {
      path:
        '/cartoes' +
        orgTerms.memberURLSingular.charAt(0).toUpperCase() +
        orgTerms.memberURLSingular.substring(1),
      name: 'membershipCardList',
      component: MembershipCardList,
      meta: {
        title: 'Cartões de ' + orgTerms.memberSingular,
        module: 'membershipCards',
        breadcrumb: 'Cartões de ' + orgTerms.memberSingular,
      },
    },
    {
      path:
        '/cartoes' +
        orgTerms.memberURLSingular.charAt(0).toUpperCase() +
        orgTerms.memberURLSingular.substring(1) +
        '/verificarVarios/:id?',
      name: 'membershipCardVerifyMultiple',
      component: MembershipCardVerifyMultiple,
      meta: {
        title: 'Verificar Cartões de ' + orgTerms.memberSingular,
        module: 'membershipCards',
        breadcrumb: 'Verificar Cartões de ' + orgTerms.memberSingular,
      },
    },
    {
      path:
        '/cartoes' +
        orgTerms.memberURLSingular.charAt(0).toUpperCase() +
        orgTerms.memberURLSingular.substring(1) +
        '/:id',
      name: 'membershipCardSingle',
      component: MembershipCardSingle,
      meta: {
        module: 'membershipCards',
        breadcrumb: 'Cartões de ' + orgTerms.memberSingular,
      },
    },
    {
      path:
        '/cartaCartoes' +
        orgTerms.memberURLSingular.charAt(0).toUpperCase() +
        orgTerms.memberURLSingular.substring(1) +
        '/:id',
      name: 'membershipCardLettersSingle',
      component: MembershipCardLettersSingle,
      meta: {
        module: 'membershipCards',
        breadcrumb: 'Carta envio de Cartão de ' + orgTerms.memberSingular,
      },
    },
    {
      path: '/v/:id',
      name: 'membershipCardVerify',
      component: MembershipCardVerify,
      meta: {
        module: 'membershipCards',
        breadcrumb: 'Cartões de ' + orgTerms.memberSingular,
      },
    },

    {
      path:
        '/configuracaoCartoes' +
        orgTerms.memberURLPlural.charAt(0).toUpperCase() +
        orgTerms.memberURLPlural.substring(1),
      name: 'membershipCardSettings',
      component: MembershipCardSettings,
      meta: {
        title: 'Configurações – Cartão de ' + orgTerms.memberPlural,
        breadcrumb: 'Configurações – Cartão de' + orgTerms.memberPlural,
        module: 'settings',
      },
    },

    {
      path: '/' + orgTerms.membershipPaymentsURL,
      name: 'PaymentsC',
      component: PaymentsC,
      meta: {
        title: orgTerms.membershipPayments,
        module: 'quotasEJoias',
        breadcrumb: orgTerms.membershipPayments,
      },
    },
    {
      path: '/' + orgTerms.membershipPaymentsURL + '/pagamentos',
      name: 'paymentsList',
      component: PaymentsList,
      meta: {
        title: orgTerms.membershipPayments + ' – Pagamentos',
        module: 'quotasEJoias',
        breadcrumb: 'Pagamentos',
      },
    },
    {
      path: '/' + orgTerms.membershipPaymentsURL + '/dividas',
      name: 'unpaid',
      component: PaymentsUnpaid,
      meta: {
        title: orgTerms.membershipPayments + ' – Dívidas',
        module: 'quotasEJoias',
        breadcrumb: 'Dívidas',
      },
    },
    {
      path: '/informacaoDePagamento/:id',
      name: 'unpaidSingle',
      component: PaymentsUnpaidSingle,
      meta: {
        title: orgTerms.membershipPayments + ' – Informação de Pagamento',
        breadcrumb: 'Dívidas',
      },
    },
    {
      path:
        '/' +
        orgTerms.membershipPaymentsURL +
        '/notificar' +
        orgTerms.memberURLPlural.charAt(0).toUpperCase() +
        orgTerms.memberURLPlural.substring(1),
      name: 'paymentsNotifyMultiple',
      component: PaymentsNotifyMultiple,
      meta: {
        title: orgTerms.membershipPayments + '– Notificar ' + orgTerms.memberPlural,
        module: 'quotasEJoias',
        breadcrumb: 'Preparar Notificação',
      },
    },
    {
      path: '/' + orgTerms.membershipPaymentsURL + '/dividas/:memberId',
      name: 'unpaidByMember',
      component: PaymentsUnpaid,
      meta: {
        title: orgTerms.membershipPayments + '– Dívidas de ' + orgTerms.memberSingular,
        module: 'quotasEJoias',
        breadcrumb: 'Dívidas',
      },
    },
    {
      path: '/' + orgTerms.membershipPaymentsURL + '/pagamentos/novo',
      name: 'paymentsNew',
      component: PaymentsSingle,
      meta: {
        title: orgTerms.membershipPayments + '– Novo Pagamento',
        module: 'quotasEJoias',
        breadcrumb: 'Novo Pagamento',
      },
    },
    {
      path: '/pagamentos/:id',
      name: 'paymentsEdit',
      component: PaymentsSingle,
      meta: {
        title: orgTerms.membershipPayments + '– Editar Pagamento',
        module: 'quotasEJoias',
        breadcrumb: 'Editar Pagamento',
      },
    },
    {
      path: '/utilizadores',
      name: 'userSettings',
      component: UserSettings,
      meta: {
        title: 'Configurações – Utilizadores',
        breadcrumb: 'Utilizadores',
        module: 'settings',
        access: ['admin', 'editor'],
      },
    },
    {
      path: '/utilizadores/novo',
      name: 'usersNew',
      component: UsersSingle,
      meta: {
        title: 'Utilizadores – Novo Utilizador',
        breadcrumb: 'Novo Utilizador',
        module: 'settings',
      },
    },
    {
      path: '/utilizadores/recuperar-password/:id',
      name: 'usersEditPassword',
      component: UsersEditPassword,
      meta: {
        title: 'Utilizadores – Recuperar Password',
        breadcrumb: 'Recuperar Password',
        module: '',
      },
    },
    {
      path: '/utilizadores/:id',
      name: 'usersEdit',
      component: UsersSingle,
      meta: {
        title: 'Editar Utilizador',
        breadcrumb: 'Editar Utilizador',
        module: 'settings',
      },
    },
    {
      path: '/relatorios',
      name: 'reportOverview',
      component: ReportOverview,
      meta: {
        title: 'Relatórios',
        breadcrumb: 'Relatórios',
      },
    },
    {
      path: '/mensagens',
      name: 'messageList',
      component: MessagesList,
      meta: {
        title: 'Mensagens',
        breadcrumb: 'Mensagens',
      },
    },
    {
      path: '/mensagens/:id',
      name: 'messagesEdit',
      component: MessagesSingle,
      meta: {
        title: 'Mensagens – Ver Mensagem',
        breadcrumb: 'Ver Mensagem',
      },
    },
    {
      path: '/configuracaoMensagens',
      name: 'messageSettings',
      component: MessageSettings,
      meta: {
        title: 'Configuração – Mensagens',
        breadcrumb: 'Configuração – Mensagens',
        module: 'settings',
      },
    },
    {
      path: '/tesouraria',
      name: 'treasuryDocList',
      component: TreasuryDocList,
      meta: {
        title: 'Tesouraria',
        breadcrumb: 'Tesouraria',
      },
    },
    {
      path: '/tesouraria/novo',
      name: 'treasuryDocsNew',
      component: TreasuryDocSingle,
      meta: {
        title: 'Tesouraria – Novo Documento',
        breadcrumb: 'Novo Documento',
      },
    },
    {
      path: '/tesouraria/multiplos',
      name: 'treasuryDocsMultiple',
      component: TreasuryDocsMultiple,
      meta: {
        title: 'Tesouraria – Múltiplos',
        breadcrumb: 'Multiplos',
      },
    },
    {
      path: '/tesoouraria/:id',
      name: 'treasuryDocsEdit',
      component: TreasuryDocSingle,
      meta: {
        title: 'Tesouraria – Editar Documento',
        breadcrumb: 'Editar Documento',
      },
    },
    {
      path: '/configuracaoTesouraria',
      name: 'treasuryDocSettings',
      component: TreasuryDocSettings,
      meta: {
        title: 'Configurações – Tesouraria',
        breadcrumb: 'Configurações de Tesouraria',
        module: 'settings',
      },
    },

    {
      path: '/developers',
      name: 'developers',
      component: Developers,
      meta: {
        title: 'Configurações – Programadores',
        breadcrumb: 'Configurações – Programadores',
        module: 'settings',
      },
    },
    {
      path: '/apiSecrets/new',
      name: 'apiSecretsNew',
      component: ApiSecretsSingle,
      meta: {
        title: 'Configurações – API – Nova Chave',
        breadcrumb: 'Configurações – API – Nova Chave',
        module: 'settings',
      },
    },
    {
      path: '/apiSecrets/:id',
      name: 'apiSecretsEdit',
      component: ApiSecretsSingle,
      meta: {
        title: 'API – Editar Chave',
        breadcrumb: 'Editar Chave API',
        module: 'settings',
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: NotFound,
    },
  ]
}

export const createRouter = (app) => {
  const r = createVueRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    strict: true,
    routes: createRoutes(app),
    scrollBehavior() {
      return { x: 0, y: 0 }
    },
  })
  r.afterEach((to, from) => {
    document.title = to.meta.title + ' | ' + orgTerms.name
  })
  return r
}
